import { isValid, parse, parseISO } from 'date-fns'
import { format, formatInTimeZone } from 'date-fns-tz'

export function formatDateDefault(date: string | number | Date) {
  try {
    return formatInTimeZone(normalizeDate(date), 'UTC', 'dd MMM yyyy')
  } catch {
    return ''
  }
}

/**
 * Normalizes non-ISO timestamp strings (e.g. `2026-05-16 18:30:24.625 -0700`,
 * `2026-05-17 00:06:50.000 Z`) into an ISO-8601 string parseable by date-fns.
 * Replaces the date/time space separator with `T` and drops the space before
 * the timezone offset. Non-string inputs are returned unchanged.
 */
function normalizeDate(date: string | number | Date) {
  if (typeof date !== 'string') return date
  return date.replace(' ', 'T').replace(/\s+(Z|[+-]\d{2}:?\d{2})$/, '$1')
}

export function normalizeDateToYyyyMmDd(value: string): string {
  if (!value) return value
  if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value

  const isoDate = parseISO(value)
  if (isValid(isoDate)) {
    return formatInTimeZone(isoDate, 'UTC', 'yyyy-MM-dd')
  }

  const slashDate = parse(value, 'MM/dd/yyyy', new Date())
  if (isValid(slashDate)) {
    return formatInTimeZone(slashDate, 'UTC', 'yyyy-MM-dd')
  }

  return value
}

export function formatTimeDefault(timestamp: number) {
  const date = new Date(timestamp)
  return format(date, 'h:mm a')
}
